module.exports = require('./helpers/bundle-url').getBundleURL('kM8PK') + "logo-dark.eefe0b7f.svg";